import { FilterSubmitButton, useFilterFormError } from '@/components/common/Filter'
import { InputSelect, InputText } from '@/components/common/Input'
import {
  FILTER_ADVANCED_PRICE_NUMBER_MIN,
  FILTER_ADVANCED_PRICE_VALUE_OPERATOR_LABELS,
  FILTER_ADVANCED_PRICE_VALUE_OPERATORS,
  type FilterAdvancedPricePartialType,
  isFilterAdvancedPriceNumberType,
} from '@/defs/filters'

import styles from './FiltersPanelAdvancedFormPrice.module.scss'

type Props = {
  filter: FilterAdvancedPricePartialType
  onUpdate: (filter: FilterAdvancedPricePartialType) => void
}

const options = FILTER_ADVANCED_PRICE_VALUE_OPERATORS.map((operator) => ({
  label: FILTER_ADVANCED_PRICE_VALUE_OPERATOR_LABELS[operator].labelLong,
  value: operator,
}))

export const FiltersPanelAdvancedFormPrice = ({ filter, onUpdate }: Props) => {
  const { number, operator } = filter
  const operatorError = useFilterFormError(!operator)
  const numberError = useFilterFormError(!isFilterAdvancedPriceNumberType(number))

  const onUpdateOperator = (operator: FilterAdvancedPricePartialType['operator']) => {
    onUpdate({ ...filter, operator })
  }

  const onUpdateNumber = (numberInput: string) => {
    const number = parseInt(numberInput)
    onUpdate({ ...filter, number: !isNaN(number) ? number : undefined })
  }

  return (
    <div className={styles.container}>
      <div className={styles.inputOperator}>
        <InputSelect
          borderColor={operatorError.warn ? 'warning' : undefined}
          colorScheme='muted'
          onSelect={onUpdateOperator}
          options={options}
          placeholder='Choose a mode'
          value={operator}
          wiggle={operatorError.wiggle}
        />
      </div>
      <div className={styles.inputNumber}>
        <InputText
          affix='$'
          autoFocus
          borderColor={numberError.warn ? 'warning' : undefined}
          colorScheme='muted'
          min={FILTER_ADVANCED_PRICE_NUMBER_MIN}
          onChange={onUpdateNumber}
          placeholder='0'
          required
          type='number'
          value={number}
          wiggle={numberError.wiggle}
        />
      </div>
      <FilterSubmitButton />
    </div>
  )
}
